<template>
    <div>
        <el-dialog v-model="newUserDialogVisible"
                   :title="newUserTittle"
                   width="30%"
                   align-center>
            <span>{{ newUserText }}</span>
            <template #footer>
                <div class="dialog-footer">
                    <el-button class="button-yellow"
                               @click="neverShowTours"
                               type="info">
                        {{$t('newUsersPrompt.neverShowDialog') }}
                    </el-button>
                    <div>
                        <el-button @click="startTour"
                                   type="primary">
                            {{$t('quickStartTour.tourName') }}
                        </el-button>
                        <el-button @click="skipTourToday">
                            {{$t('newUsersPrompt.nextTime') }}
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>

        <el-tour v-model="tourStart">
            <el-tour-step v-for="step in tourSteps"
                          :key="step.id"
                          :target="step.target"
                          :title="$t(step.title)"
                          :description="$t(step.description)" />

        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { userGuideService } from './userGuideService'
    import { navigationService } from '@/services/navigationService'
    import { userSettingsService } from '@/services/userSettingsService'

    import { ElMessage } from 'element-plus'

    const delayHours = 2

    export default defineComponent({
        created() {
            this.init();
        },
        data() {
            return {
                newUserDialogVisible: false,
                newUserTittle: this.$t('newUsersPrompt.welcomeMsg'),
                newUserText: this.$t('newUsersPrompt.weAreHappyToSeeYou'),
                
                infoMessageText: this.$t('newUsersPrompt.mareInfoHere'),

                userSettingsService: new userSettingsService(),

                tourStart: false,
                tourSteps: userGuideService.getQuickStartGuide(),
            };
        },
        computed: {
            homePage(): boolean {
                return this.$route.name == navigationService.homePageName
            },
        },
        methods:{
            async init() {
                if (!this.homePage) {
                    return;
                }

                const userTourConfig = await this.userSettingsService.getUserTourConfig();

                if(userTourConfig == null){
                    this.showNewUserDialog();
                    return;
                }

                if(userTourConfig.introTourFinished){
                    return;
                }

                const showTour = this.showTourNow(userTourConfig.lastTourDate);
                if (!showTour){
                    return;
                }

                this.showNewUserDialog();
            },

            showTourNow(lastShownTour: string): boolean {
                if (!lastShownTour) {
                    return true;
                }

                const lastShownDate = new Date(lastShownTour);
                const currentDate = new Date();
                const timeDifference = currentDate.getTime() - lastShownDate.getTime();
                const hoursDifference = timeDifference / (1000 * 60 * 60);

                return hoursDifference >= delayHours;
            },

            showNewUserDialog(){ 
                this.newUserDialogVisible = true;    
            },
            async startTour(){
                await this.userSettingsService.markTourAsPassed();

                const result = document.getElementById("tab-fileUpload");
                if (result != null) {
                    result.click();
                }

                this.tourStart = true;
                this.newUserDialogVisible = false;
            },
            async skipTourToday(){
                this.newUserDialogVisible = false;    
                await this.userSettingsService.skipTourToday();
            },
            async neverShowTours(){
                this.newUserDialogVisible = false;    
                this.showInfoMessage();
                await this.userSettingsService.markTourAsPassed();
            },
            showInfoMessage() {
                ElMessage({
                    showClose: true,
                    message: this.infoMessageText,
                    type: 'success',
                })
            },
        }
    })
</script>

<style lang="scss" scoped>
    .dialog-footer {
        display: flex;
        justify-content: space-around;
        align-items: center;

        & > button {
            margin: 20px;
        }
    }

    @media only screen and (max-width: 1500px) {
        .dialog-footer {
            flex-wrap: wrap;
        }
    }
</style>